import React from 'react'
import './../App.css'
import './../style/contact.css'
import Pagetitle from './../components/pagetitle/Pagetitle';
import rotateicon from './../Images/download.png';
import contactimg from './../Images/contact-fb04464fe760be65b352a1a00c08abb2.png'
export default function Contact() {
    return (
        <div>
            <Pagetitle pagename='Contact' parentpage='Home' />
            <section className="contact_info_area pt-100 pb-70">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4 col-md-6">
                            <div className="contact_info_box">
                                <div className="hidden_icon">
                                    <i className='bx bx-map'></i>
                                </div>
                                <div className="icon">
                                    <i className='bx bx-map'></i>
                                </div>
                                <h3>Our Address</h3>
                                <p>1st Floor Kallar House, North Colony, Mithi, Pakistan</p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="contact_info_box">
                                <div className="hidden_icon">
                                    <i className='bx bx-phone-call'></i>
                                </div>
                                <div className="icon">
                                    <i className='bx bx-phone-call'></i>
                                </div>
                                <h3>Contact</h3>
                                <p>Mobile: <a href="tel:+92-33-22511711">+92-33-22511711</a></p>
                                <p>Email: <a href="mailto:info@hunar.com">info@hunar.com</a></p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 offset-lg-0 offset-md-3">
                            <div className="contact_info_box">
                                <div className="hidden_icon">
                                    <i className='bx bx-time-five'></i>
                                </div>
                                <div className="icon">
                                    <i className='bx bx-time-five'></i>
                                </div>
                                <h3>Hours of Operation</h3>
                                <p>Monday - Friday: 09:00 - 17:00</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="contact_area pb-100">
                <div className="container">
                    <div className="section_title">
                        <div className='sub-title'><img src={rotateicon} /> GET IN TOUCH</div>
                        <h2>Request A Free Consultation</h2>
                    </div>
                    <div className="row">
                        <div className="col-lg-6 col-md-12">
                            <div className="contact_image">
                                <img src={contactimg}/>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                            <div className="contact_form">
                                <form>
                                    <div className="row">
                                        <div className="col-lg-12 col-md-6">
                                            <div className="form_group">
                                                <input type="text" name="Name" placeholder="Your Name"required/>
                                            </div>
                                        </div>
                                        <div className="col-lg-12 col-md-6">
                                            <div className="form_group">
                                                <input type="email" name="email" placeholder="Your Email Address" required />
                                            </div>
                                        </div>
                                        <div className="col-lg-12 col-md-12">
                                            <div className="form_group">
                                                <input type="number" name="Number" placeholder="Number (Optional)"/>
                                            </div>
                                        </div>
                                        <div className="col-lg-12 col-md-12">
                                            <div className="form_group">
                                                <input type="text" name="Subject" placeholder="Subject" required />
                                            </div>
                                        </div>
                                        <div className="col-lg-12 col-md-12">
                                            <div className="form_group">
                                                <textarea name="" id="" cols="30" rows="6" spellCheck="false" placeholder='Your message (optional)'></textarea>
                                            </div>
                                        </div>
                                        <div className="col-lg-12 col-md-12">
                                        <button type="submit" className='button'>Send Message <span></span></button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}
